var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollapseContent = function SvgCollapseContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "collapse_content_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#collapse_content_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 15H6a.97.97 0 0 1-.713-.287A.97.97 0 0 1 5 14q0-.424.287-.713A.97.97 0 0 1 6 13h4q.424 0 .713.287.287.288.287.713v4q0 .424-.287.712A.97.97 0 0 1 10 19a.97.97 0 0 1-.713-.288A.97.97 0 0 1 9 18zm6-6h3q.424 0 .712.287Q19 9.576 19 10q0 .424-.288.713A.97.97 0 0 1 18 11h-4a.97.97 0 0 1-.713-.287A.97.97 0 0 1 13 10V6q0-.424.287-.713A.97.97 0 0 1 14 5q.424 0 .713.287Q15 5.576 15 6z"
  }))));
};
export default SvgCollapseContent;